import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {RequestButtonTypes} from '../../../../common/components/request-button/request-button.component';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {InputType} from '../../../../common/components/form-builder/form-builder.component';
import {TrabajadoresApiService} from '../../../../service/api/trabajadores-api.service';
import {BaseView} from '../../../base-view';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ClienteModel } from 'src/app/models/cliente.model';
import { ClientesApiService } from 'src/app/service/api/clientes-api.service';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Filtering } from 'src/app/service/filtering/filtering';
import moment from 'moment';
import { Utils } from 'src/app/common/utils';

import type { OnInit } from '@angular/core';
import type { ItemInterface } from '../../../../common/components/form-builder/form-builder.component';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { MessageService, TreeNode } from 'primeng/api';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-maquinaria',
    standalone: false,
    templateUrl: './maquinaria.component.html',
    styleUrls: ['./maquinaria.component.scss'],
    providers: [MessageService]
})
export class MaquinariaComponent extends BaseView<MaquinariaModel> implements OnInit {

    public currentUser = StorageManager.getUser();

    public appName = environment.appName;
    
    public activateREA = environment.features.activateREA;
    
    public applicationType = environment.features.applicationType;

    public serverUrl = environment.serverUrl;
    public showMaquinariaMenu = environment.features.showMaquinariaMenu;
    public showMaquinariaGps = environment.features.showMaquinariaGps;
    public showMaquinariaVidaUtil = environment.features.showMaquinariaVidaUtil;
    public hasClients = environment.features.hasClients;
    public userCanSeeClientes = this.hasClients &&
        (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));
    public showAplicadoresActivo = environment.features.showAplicadoresActivo;
    public filterAplicadoresByClient = environment.features.filterAplicadoresByClient;
    public showMaquinariaMostrarTodos = environment.features.showMaquinariaMostrarTodos
        ? this.currentUser.rol === 'admin'
        : false;
    public showMaquinariaClienteAsignado = environment.features.showMaquinariaClienteAsignado;
    public showMaquinariaPropietario = environment.features.showMaquinariaPropietario;
    public clienteName = environment.features.clienteName;
    public titleActivo = environment.features.titleActivoMaqTra;

    public filter: Filtering<MaquinariaModel> = new Filtering<MaquinariaModel>();
    public showAll = false;
    public getRequest: RequestHandler<MaquinariaModel[]> = this.trabajadoresApi.maquinariaGET;
    public deleteRequest: RequestHandler<MaquinariaModel> = this.trabajadoresApi.maquinariaDELETE;
    public pathToForm = 'maquinaria-form';
    public menuItemId = 'maquinaria';
    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public sub$: Subscription = new Subscription;
    public clientes: ClienteModel[] = [];
    
    public override canShow: Record<string, boolean> = {};
    public override model: MaquinariaModel = {};

    public imagenAdjunto: string | null = null;
    public imagenAdjuntoDoc: string | null = null;
    public precioHora = environment.features.precioHora;


    public formFields: ItemInterface<object>[] = [
        {
            label: 'Nombre', 
            field: 'nombre', 
            inputType: {type: InputType.TEXT}
        },
        {
            label: 'Tipo', 
            field: 'tipo', 
            inputType: {type: InputType.TEXT}
        },
        {
            label: 'Capacidad (Litros)', 
            field: 'capacidad', 
            inputType: {type: InputType.TEXT}
        },
        {
            label: 'ROMA', 
            field: 'roma', 
            inputType: {type: InputType.TEXT}
        },
        {
            label: this.appName === 'innovia' ? this.clienteName : 'Propietario', 
            field: 'cliente', 
            inputType: {type: InputType.TEXT}, 
            visible: this.showMaquinariaClienteAsignado
        },
        {
            label: 'Fecha Adquisición', 
            field: 'fecha_adquisicion', 
            inputType: {type: InputType.TEXT}
        },
        {
            label: 'Fecha Última Inspección ITEAF', 
            field: 'fecha_ultima_inspeccion', 
            inputType: {type: InputType.TEXT}
        },
        {
            label: 'Fecha Caducidad ITEAF',
            field: 'fecha_caducidad',
            inputType: {type: InputType.ONLY_TEXT},
            style: 'color: black'
        },
        {
            label: 'Fecha Alerta', 
            field: 'fecha_alerta', 
            inputType: {type: InputType.TEXT},
            visible: this.appName === 'agrotata'
        },
        {
            label: 'Fecha Último Mantenimiento',
            field: 'fecha_ultimo_mantenimiento',
            inputType: {type: InputType.TEXT},
            visible: this.appName === 'detorres'
        },
        {
            label: 'Vida Útil Estimada (Horas)',
            field: 'vida_util',
            inputType: {type: InputType.TEXT},
            visible: this.showMaquinariaVidaUtil
        },
        {
            label: 'Identificador GPS', 
            field: 'gps', 
            inputType: {type: InputType.TEXT}, 
            visible: this.showMaquinariaGps
        },
        {
            label: 'IMEI', 
            field: 'imei', 
            inputType: {type: InputType.TEXT}, 
            visible: this.showMaquinariaGps
        },
        {
            label: 'Boquillas', 
            field: 'boquillas_nombres', 
            inputType: {type: InputType.TEXT}, 
            visible: (this.appName === 'manezylozano')
        },
        {
            label: 'Precio (€)',
            field: 'precio',
            inputType: {type: InputType.TEXT},
            visible: (this.appName === 'detorres')
        },
        {
            label: 'Coste/hora (€)', 
            field: 'precio_hora', 
            inputType: {type: InputType.TEXT}, 
            visible: this.precioHora
        },
        {
            label: 'Proveedor',
            field: 'proveedor',
            inputType: {type: InputType.TEXT},
            visible: this.appName === 'sirga',
        },
        {
            label: this.titleActivo, 
            field: 'activo', 
            inputType: {type: InputType.RO_SWITCH}, 
            visible: this.showAplicadoresActivo
        },
        {
            label: 'Recibir mail tratamientos', 
            field: 'mail_trat', 
            inputType: {type: InputType.RO_SWITCH}, 
            visible: this.appName === 'manezylozano' 
        },
        {
            hasLabel: false, 
            field: 'adjunto', 
            inputType: {type: InputType.EMPTY}
        },
        {
            label: 'Observaciones',
            field: 'observaciones',
            inputType: {type: InputType.TEXTAREA},
            visible: this.appName === 'detorres'
        }
    ];

    public cols: ColInterface[] = [
        {header: 'Nombre', field: 'nombre'},
        {header: 'Tipo', field: 'tipo'},
        {header: 'Precio', field: 'precio', visible:this.appName === 'detorres'},
        {header: 'Observaciones', field: 'observaciones', visible:this.appName === 'detorres'},
        {header: 'Capacidad\xa0(l)', field: 'capacidad', visible:this.appName !== 'detorres'},
        {header: 'ROMA', field: 'roma', visible:this.appName !== 'detorres'},
        {header: 'Adquisición ', field: 'fecha_adquisicion', visible:this.appName !== 'detorres'},
        {header: 'Última\xa0inspección\xa0ITEAF', field: 'fecha_ultima_inspeccion'},
        {header: 'Caducidad\xa0ITEAF', field: 'fecha_caducidad', visible: this.appName === 'agrotata'},
        {header: 'Fecha Alerta', field: 'fecha_alerta' },
        {header: 'Último\xa0mantenimiento', field: 'fecha_ultimo_mantenimiento', visible:this.appName === 'detorres'},
        {header: 'Coste/hora (€)', field: 'precio_hora' , visible: this.precioHora && this.appName !== 'detorres'},
        {header: this.titleActivo, field: 'activo', width: '60px', visible:this.appName !== 'detorres'},
        {
            header: this.appName === 'innovia' ? this.clienteName : 'Propietario', 
            field: 'cliente', 
            visible: this.showMaquinariaClienteAsignado
        },
        {header: 'Usuario', field: 'usuario_nombre', visible: this.showMaquinariaMostrarTodos},
        {header: 'Empresa', field: 'empresa', visible: this.appName === 'avafitogest'},
        {header: 'Horas acumuladas', field: 'horas_acumuladas', visible: this.appName === 'agrotata'},
    ];

    constructor(
        public trabajadoresApi: TrabajadoresApiService,
        public clientesApi: ClientesApiService,
        private dashboard: DashboardService,
        private router: Router,
        private messageService: MessageService,
        private http: HttpClient
    ) {
        super(dashboard, trabajadoresApi.maquinariaGET, trabajadoresApi.maquinariaDELETE);
    }

    ngOnInit() {
        this.showAll = Utils.initShowAll('showAllmaquinarias');
        this.initFilter();
        this.getClientes();

        if (this.appName === 'agrotata') {
            this.trabajadoresApi.maquinariaGET.response((maquinarias: MaquinariaModel[]) => {
                const hoy = moment();

                maquinarias.forEach(maq => {
                    if (!maq.fecha_alerta) { return; }

                    const fechaAlerta = moment(maq.fecha_alerta, 'DD/MM/YYYY');

                    if (hoy.isAfter(fechaAlerta)) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Alerta vencida',
                            detail: `La máquina "${maq.nombre}" tiene la fecha de alerta vencida (${maq.fecha_alerta}).`
                        });
                    }
                });

                this.checkHorasAcumuladas(maquinarias);
            });
        }

        if (this.showMaquinariaMenu) {
            this.dashboard.setMenuItem(this.menuItemId);
        } else {
            this.dashboard.setSubmenuItem('_aplicadores', this.menuItemId);
        }
    }

    public changeShowAll(){
        sessionStorage.setItem('showAllmaquinarias', this.showAll === true ? 'true' : 'false' );
    }    

    public getClientes() {
        this.clientesApi.clientesGET.safePerform();
        this.clientesApi.clientesGET.response(clientes => {
            this.clientes = clientes;
        });
    }

    public add() {
        if (this.filterAplicadoresByClient && !StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', 'crear-maquinaria']);
        }
    }

    public edit(data: MaquinariaModel) {
        this.router.navigate(['dashboard', 'editar-maquinaria', data.id]);
    }

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public override show(modal: string, data: MaquinariaModel) {
        super.show(modal, data);

        this.model.activo = [1, '1', true, 'true'].includes(this.model.activo ?? '');

        if ( this.appName === 'manezylozano' ) {
            this.model.mail_trat = [1, '1', true, 'true'].includes(this.model.mail_trat ?? '');
        }
        
        this.getVisitImages();
    }

    public override hide(modal: string) {
        this.model = {};
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    public verAdjunto() {
        if (this.model.adjunto) {
            const myWindow = window.open('about:blank', '_blank', 'width=600, height=600');
            myWindow?.location.assign(environment.serverUrl + 'fotos_maquinaria/' + this.model.adjunto);
            myWindow?.focus();
        } else {
            alert('Esta máquina no tiene fotos.');
        }
    }

    public globalConditionalStyle(
        value: string, col: ColInterface,  
        _colGroup: ColInterface[], 
        row: TreeNode<MaquinariaModel>
    ): ColStylesInterface {
        const maquinaria = row.data as MaquinariaModel;
        
        if (col.field === 'fecha_alerta') {
            const hoy = moment(moment().format('MM-DD-YYYY' + ' 00:00:00'));

            if (hoy.isAfter(moment(value, 'DD/MM/YYYY'))) {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#f44242',
                    }
                };
            } else if (hoy.isSameOrAfter(moment(value, 'DD/MM/YYYY').subtract(3, 'months'))) {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#ff9a02',
                    }
                };
            }
            return { textAlign: 'center' };
        }

        if (col.field === 'fecha_caducidad') {
            
            const fechaUltimaInspeccion = maquinaria.fecha_ultima_inspeccion ?? '';
            let tiempoAntes = moment();
            
            if (this.appName === 'prodalbar') {
                tiempoAntes = moment(value, 'DD/MM/YYYY').subtract(1, 'years');
            } else {
                tiempoAntes = moment(value, 'DD/MM/YYYY').subtract(3, 'months');
            }
            
            const hoy = moment(moment().format('MM-DD-YYYY' + ' 00:00:00'));

            if (hoy.isAfter(moment(value, 'DD/MM/YYYY')))  {

                if (!fechaUltimaInspeccion) {
                    return {
                        textAlign: 'center',
                        rowStyle: {
                            backgroundColor: '#f44242',
                            textAlign: 'center'
                        },  
                    };
                } else {
                    let periodoAnyos = 0;
                    
                    periodoAnyos = (moment(fechaUltimaInspeccion, 'DD/MM/YYYY').year() < 2020) ? 5 : 3;
                    const fecha = moment(fechaUltimaInspeccion, 'DD/MM/YYYY').add(periodoAnyos, 'years');
                    
                    tiempoAntes = moment();
                    
                    if (this.appName === 'prodalbar') {
                        tiempoAntes = moment(fechaUltimaInspeccion, 'DD/MM/YYYY').add(periodoAnyos, 'years').subtract(1, 'years');
                    } else {
                        tiempoAntes = moment(fechaUltimaInspeccion, 'DD/MM/YYYY').add(periodoAnyos, 'years').subtract(3, 'months');
                    }
                    if (hoy.isSameOrAfter(tiempoAntes) && hoy.isSameOrBefore(fecha)) {
                        return {
                            textAlign: 'center',
                            rowStyle: {
                                backgroundColor: '#ff9a02',
                            }
                        };
                    } else if (hoy.isAfter(fecha)) {
                        return {
                            textAlign: 'center',
                            rowStyle: {
                                backgroundColor: '#f44242',
                            },  
                        };
                    }
                }
            } else if (hoy.isSameOrAfter(tiempoAntes) && hoy.isSameOrBefore(moment(value, 'DD/MM/YYYY'))) {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#ff9a02',
                    }
                };
            }
            return {textAlign: 'center'};
        }

        if (Utils.isNumber(value?.toString() ?? '') || col.field === 'capacidad' || col.field === 'roma' ) {
            return {
                textAlign: 'right',
                paddingRight: '40px'
                
            };
        }
        return{ textAlign: 'center'};
    }


    public globalVisualTransform(value: string | number | boolean, col: ColInterface): string {
        if (col.field === 'activo') {
            return ([1, '1', true, 'true', 'Sí'].includes(value)) ? 'Sí' : 'No';
        } else if (col.field === 'horas_acumuladas') {
            const total = parseFloat(value?.toString() ?? '0');
            if (isNaN(total)) { return '-'; }
            const horas = Math.floor(total);
            const minutos = Math.round((total - horas) * 60);
            return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`;
        } else {
            return value.toString();
        }
    }

    public getVisitImages() {
        if (this.model.adjunto) {
            fetch(environment.serverUrl + 'fotos_maquinaria/' + (this.model.adjunto || {}))
                .then((r) => {
                    if (r.status === 200) {
                        this.imagenAdjunto = environment.serverUrl + 'fotos_maquinaria/' + (this.model.adjunto  || {});
                    }
                    return;
                }).catch (e => {
                    console.log('catch en getPosition: ' + e);
                }
                );
        } else if (this.model.adjunto_pdf) {
            fetch(environment.serverUrl + 'fotos_maquinaria/' + (this.model.adjunto_pdf || {}))
                .then((r) => {
                    if (r.status === 200) {
                        this.imagenAdjuntoDoc = environment.serverUrl + 'fotos_maquinaria/' + (this.model.adjunto_pdf  || {});
                    }
                    return;
                }).catch (e => {
                    console.log('catch en getPosition: ' + e);
                }
                );
        }else {
            this.imagenAdjuntoDoc = null;
            this.imagenAdjunto = null;
        }
    }

    verAdjuntoPdf() {
        const myWindow = window.open('about:blank', '_blank', 'width=600, height=600');
        myWindow?.location.assign(environment.serverUrl + 'fotos_maquinaria/' + this.model.adjunto_pdf);
        myWindow?.focus();
    }

    private initFilter() {
        this.filter.addFilter((data: TreeNode<MaquinariaModel>[] | void) => (data || [])
            .filter((it: TreeNode<MaquinariaModel>) => it)
            .filter((it: TreeNode<MaquinariaModel>) => {
                const maquinaria = it as MaquinariaModel;

                if (this.currentUser.rol === 'user' && this.appName === 'manezylozano') {
                    return this.currentUser.id === maquinaria.id_usuario;
                } 
                else if (this.showMaquinariaMostrarTodos && !this.showAll) {
                    return this.currentUser.id === maquinaria.id_usuario;
                }
                else if (this.appName === 'innovia'  && this.currentUser.rol === 'user'){
                    return this.currentUser.id_cliente === maquinaria.id_cliente;
                }
                else if (this.activateREA && (Boolean((StorageManager.getClient()?.id)))){
                    return StorageManager.getClient()?.id === maquinaria.id_cliente ||
                    (maquinaria.id_comercio !== null && maquinaria.id_comercio?.toString() !== '0');
                };
                return true;
            })
        );
    }

    private checkHorasAcumuladas(maquinarias: MaquinariaModel[]): void {
        const tablas = [
            'fitosanitarios_get',
            'fertilizantes_get',
            'tareas_bio_get',
            'otros_get',
            'siembra_get'
        ];

        maquinarias.forEach(maq => {
            if (!maq.id) { return; }

            const requests = tablas.map(p2 =>
                this.http.get<any[]>(
                    `${environment.serverUrl}ws/index.php?p1=tareas&p2=${p2}&id_maquinaria=${maq.id}`
                ).toPromise().catch(() => [])
            );

            Promise.all(requests).then(results => {
                const horasTotales = (results as any[])
                    .flatMap(res => res?.data ?? res ?? [])
                    .reduce((sum: number, tarea: any) => {
                        const raw: string = tarea?.horas_totales ?? '0';
                        let decimal = 0;

                        if (raw.includes(':')) {
                            const parts = raw.split(':').map(Number);
                            const h = parts[0] ?? 0;
                            const m = parts[1] ?? 0;
                            decimal = (isNaN(h) ? 0 : h) + (isNaN(m) ? 0 : m) / 60;
                        } else {
                            decimal = parseFloat(raw);
                            if (isNaN(decimal)) { decimal = 0; }
                        }

                        return sum + decimal;
                    }, 0);

                maq.horas_acumuladas = horasTotales;

                if (horasTotales >= 500) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Alerta 500h',
                        detail: `"${maq.nombre}" ha alcanzado las 500h: Cambiar Aceite Transmisión.`
                    });
                } else if (horasTotales >= 250) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Alerta 250h',
                        detail: `"${maq.nombre}" ha alcanzado las 250h: Cambiar Aceite y Filtros.`
                    });
                }
            });
        });
    }
}
